export enum Direction {
  IN = 0,
  OUT = 1,
  IN_OUT = 2
}
